var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-popup-menu-item"},[_c('ed-list-item',{attrs:{"action":""}},[_c('div',{staticClass:"content",class:_vm.cssClass || ''},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }